<div class="card cert-chart">
  @if (!noDataFound()) {
    <div class="cert-chart__left">
      <h4 class="cert-chart__title">{{ chartTitle() }}</h4>
      @if (isBrowser()) {
        <highcharts-chart [Highcharts]="highcharts" [options]="chartOptions" (chartInstance)="setChartInstance($event)">
        </highcharts-chart>
      }
    </div>
    <div class="cert-chart__right">
      <h4 class="cert-chart__title">{{ legendTitle() }}</h4>
      <ul class="cert-chart__classifications">
        @for (group of legendGroups(); track group.name) {
          <li>
            <header class="cert-chart__classifications-header">
              <h4 class="cert-chart__classifications-title">{{ group.name }}</h4>
              <div class="cert-chart__classifications-percentage">{{ group.percentage.toFixed(1) }}%</div>
            </header>
            <div class="cert-chart__classifications-bar">
              <span class="cert-chart__classifications-progress" [style.width.%]="group.percentage"></span>
            </div>
          </li>
        }
      </ul>
    </div>
  } @else {
    <div class="cert-chart__empty-state">
      <i></i>
      <span>{{ "Chart.TrafficGraph.NoDataFound" | translate }}</span>
    </div>
  }
</div>
